import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import ActionConfirmationModal from '@organisms/actions/ActionConfirmationModal/ActionConfirmationModal';
import { RouteNames } from '@/router/router.types';
import { buildUrlWithReturnTo, getCurrentAsReturnTo, sanitizeReturnTo } from '@srm/core/routing';

export class RegisterExecutor extends DocBaseActionExecutor {
    runInternal = (
        _objId: string,
        _parentId: string | undefined,
        action: IBaseAction,
        _rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        if (!action.options?.confirmation) {
            this.doAction(action, completeHandler);
        }
    };

    private doAction(action: IBaseAction, completeHandler: ((isSucceed: boolean) => void) | undefined) {
        const targetPath = RouteNames.DOCUMENT_CREATE_BY_ACTION.replace(':actId', action.key).replace(
            '/:draftId?',
            '',
        );

        if (this.navigate) {
            if (action.options?.newTab) {
                window.open(targetPath, '_blank', 'noopener,noreferrer');
            } else {
                // Если уже на create-странице — пропагируем существующий returnTo;
                // иначе — текущий location становится точкой возврата.
                const existingReturnTo = sanitizeReturnTo(
                    new URLSearchParams(this.location?.search ?? '').get('returnTo'),
                );
                const returnTo =
                    existingReturnTo ??
                    getCurrentAsReturnTo(
                        this.location?.pathname ?? '',
                        this.location?.search ?? '',
                        this.location?.hash ?? '',
                    );
                this.navigate(buildUrlWithReturnTo(targetPath, returnTo));
            }
        } else {
            window.location.href = `.${targetPath}`;
        }
        completeHandler && completeHandler(false);
    }

    visualElementInner = () => {
        return this._action?.options?.confirmation ? (
            <ActionConfirmationModal
                title={this._action.options.confirmation.title}
                message={this._action.options.confirmation.message}
                okButtonText={this._action.options.confirmation.okButtonText}
                cancelButtonText={this._action.options.confirmation.cancelButtonText}
                onOkClick={() => {
                    if (this._action) {
                        this.doAction(this._action, this._completeHandler);
                    }

                    return new Promise<void>((resolve) => {
                        resolve();
                    });
                }}
                onCancelClick={() => {
                    this._completeHandler && this._completeHandler(false);
                }}
            />
        ) : (
            <></>
        );
    };
}
